<!--paper-preview:试卷预览 2024/08/27 18:25:25 YuAng-->

<template>
  <div class="yj-paper-preview">
    <page-header title="" :paths="['试卷管理', '切录题', '试卷预览']"></page-header>
    <p class="paper-title bold">{{exam.examName}}_{{exam.subjectName}}</p>
    <!-- 大题列表 -->
    <ul class="big-list">
      <li v-for="(big, index) in list" :key="'big' + index" class="big-li">
        <p class="big-title bold">{{big.bigNum}}、{{big.pattern.name}}</p>
        <!-- 小题列表 -->
        <ul class="small-list">
          <li v-for="(small, sIndex) in big.items" :key="index + 'small' + sIndex" class="small-li">
            <div class="ques-content">
              <span style="font-weight: 500">{{small.raw.smallNum}}.&nbsp;</span>
              <div v-html="contentHtml(small.stem.contentHtml)"></div>
            </div>
            <div v-if="small.answer" class="ques-content">
              <span style="font-weight: 500">答案：</span>
              <div v-html="contentHtml(small.answer.contentHtml)"></div>
            </div>
            <div v-if="small.explanation" class="ques-content">
              <span style="font-weight: 500">解析：</span>
              <div v-html="contentHtml(small.explanation.contentHtml)"></div>
            </div>
            <div v-if="small.points" class="ques-content">
              <span style="font-weight: 500">考察知识点：</span>
              <template v-if="small.points.length">
                <span v-for="(point, index) in small.points" :key="point">
                  {{point.name}}<i v-show="index < small.points.length - 1">，</i>
                </span>
              </template>
              <span v-else style="color: #ff4c3b;">未设置</span>
            </div>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>
<script>
import PageHeader from '@/v2/views/components/PageHeader.vue'
export default {
  components: { PageHeader },
  name: 'paper-preview',
  data () {
    return {
      quesTypeDict: {
        'CHOICE': '单选题'
      }
    }
  },
  computed: {
    list: function () {
      return this.$route.params.quesList
    },
    exam: function () {
      return this.$route.params.exam
    }
  },
  methods: {
    contentHtml (content) {
      return `${content ? content : '<span style="color: #ff4c3b;">未设置</span>'}`
    }
  }
}
</script>

<style scoped>
.yj-paper-preview {
  margin: auto calc(50% - 600px);
  font-size: 14px;
  background-color: white;
}

.paper-title {
  font-size: 16px;
  padding: 32px;
  text-align: center;
}

.big-list {
  padding: 0 32px;
  height: calc(100vh - 180px);
  overflow: auto;
  padding-bottom: 50px;
}

.big-title {
  padding: 20px 0;
}

.small-list ::v-deep img {
  max-width: 80%;
  vertical-align: bottom;
}

.red {
  color: #ff4c3b;
}

.bold {
  font-weight: 500;
}

.ques-content {
  margin-bottom: 8px;
  line-height: 1.5;
  display: flex;
  flex-wrap: wrap;
}
</style>